
function isObject (val) {
  return (typeof val) === 'object' && val != null
}

function interpolate (key, data) {
  return key.replace(/\{([^}]+)\}/g, function (_1_, match) {
    return data[match] || ''
  })
}

function $t (content, key, data) {
  if (!isObject(content)) {
    return ''
  }

  const index = (key != null && key !== false && key !== true) ? String(key) : ''

  const rv = content[index] || index
  return (isObject(data) ? interpolate(rv, data) : rv)
}

export default {
  $t: $t
}
